<template>
  <div>
    <div class="slider">
      <div class="rev_slider_wrapper">
        <div id="slider1" class="rev_slider" data-version="5.0">
          <ul>
            <li
              data-transition="zoomout"
              data-slotamount="10"
              data-masterspeed="3000"
            >
              <img
                src="/dist/assets/images/ChurchImages/rupc_church_banner_003.jpg"
                alt="slidebg1"
                class="rev-slidebg"
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                data-no-retina
              />
              <div
                class="tp-caption slide-title1 tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['20','20','20','20']"
                data-y="['150','150','150','150']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['39','39','29','19']"
                data-lineheight="['39','39','29','19']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:90;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:left(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="1700"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="; white-space: nowrap;"
              >
                Welcome to the Rightway<br />
                United Pentecostal Church
              </div>
              <!--<div class="tp-caption slide-subtitle1 tp-resizeme rs-parallaxlevel-2" data-x="['left','left','left','left']" data-hoffset="['0','0','0','0']" data-y="['250','250','250','250']" data-voffset="['0','0','0','0']" data-fontsize="['18','18','15','15']" data-lineheight="['18','18','15','15']" data-width="['none','none','none','400']" data-height="none" data-whitespace="['nowrap','nowrap','nowrap','normal']" data-transform_idle="o:1;" data-transform_in="z:0;rX:0;rY:45;rZ:30;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;" data-transform_out="x:right(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;" data-start="1900" data-splitin="none" data-splitout="none" data-responsive_offset="on" style="white-space: nowrap;">Under The Guidelines Of Pope Francis</div>-->
              <router-link
                to="/about"
                class="tp-caption slide-button colored-box tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['20','20','20','20']"
                data-y="['280','280','280','280']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['13','13','13','13']"
                data-lineheight="['15','15','13','13']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="y:bottom(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="2100"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space: nowrap;"
                >Read More</router-link
              >
              <div
                class="tp-caption tp-resizeme rs-parallaxlevel-2"
                data-x="['right','right','right','right']"
                data-hoffset="['20','20','20','20']"
                data-y="['bottom','bottom','bottom','bottom']"
                data-voffset="['0','0','0','0']"
                data-transform_idle="o:1;"
                data-transform_in="y:bottom(R);z:0;rX:90;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Elastic.easeInOut;"
                data-transform_out="x:right(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="2300"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                data-no-retina
              >
                <img
                  src="/dist/assets/images/ChurchImages/rupc_pedro_patrick_007.png"
                  alt=""
                  data-ww="['400px','400px','200px','200px']"
                  data-hh="['390px','390x','150px','150px']"
                  itemprop="image"
                  data-no-retina
                />
              </div>
            </li>
            <li
              data-transition="zoomin"
              data-slotamount="10"
              data-masterspeed="3000"
            >
              <img
                src="/dist/assets/images/ChurchImages/rupc_church_banner_004.jpg"
                alt="slidebg2"
                class="rev-slidebg"
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                data-no-retina
              />
              <div
                class="tp-caption slide-title2 tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['20','20','20','20']"
                data-y="['100','100','100','100']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['37','37','27','27']"
                data-lineheight="['37','37','27','27']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:1.5;sY:0.9;skX:0.9;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:left(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="1700"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="; white-space: nowrap;"
              >
                Rightway is a community church that believes in Jesus, <br />
                and we are His hands, His feet and His heart- extended<br />
                encouraging lives to change with grace,<br />
                comfort and salvation!
              </div>
              <!-- <div
                class="tp-caption colored-box slide-subtitle2 tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['20','20','20','20']"
                data-y="['170','170','170','170']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['18','18','15','15']"
                data-lineheight="['25','25','20','20']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:left(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="1900"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space: nowrap; color: #ffffff;"
              >
                Faith to do the impossible with God for God regardless of the
                cost
              </div> -->
              <!-- <div
                class="tp-caption white-bg slide-subtitle2 tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['20','20','20','20']"
                data-y="['220','220','220','220']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['18','18','15','15']"
                data-lineheight="['25','25','20','20']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:left(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="2100"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space: nowrap;"
              >
                Hope for the best even when the situation is hopeless
              </div> -->
              <router-link
                to="/donate"
                class="tp-caption colored-box slide-button cmi-donate tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['20','20','20','20']"
                data-y="['300','300','300','300']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['14','14','13','13']"
                data-lineheight="['15','15','13','13']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:-45;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:left(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="2300"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space: nowrap;"
                ><i class="fa tp-shape fa-shopping-cart"></i>Donate
                Now</router-link
              >
            </li>
            <li
              data-transition="fade"
              data-slotamount="10"
              data-masterspeed="3000"
            >
              <img
                src="/dist/assets/images/ChurchImages/montreal_city_night_001.jpg"
                alt="slidebg3"
                class="rev-slidebg"
                data-bgposition="center center"
                data-bgfit="cover"
                data-bgrepeat="no-repeat"
                data-no-retina
              />
              <!-- <div
                class="tp-caption slide-title3 tp-resizeme rs-parallaxlevel-2"
                data-x="['500','500','500','500']"
                data-hoffset="['0','0','0','0']"
                data-y="['100','100','100','100']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['36','36','26','26']"
                data-lineheight="['36','36','26','26']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="x:[105%];z:0;rX:45deg;rY:0deg;rZ:90deg;sX:1;sY:1;skX:0;skY:0;s:2000;e:Power4.easeInOut;"
                data-transform_out="y:[100%];s:1000;e:Power2.easeInOut;s:1000;e:Power2.easeInOut;"
                data-mask_in="x:0px;y:0px;"
                data-mask_out="x:inherit;y:inherit;"
                data-start="1700"
                data-splitin="chars"
                data-splitout="none"
                data-responsive_offset="on"
                data-elementdelay="0.05"
                style="white-space: nowrap;"
              >
                Come and experience
              </div> -->
              <!-- <div
                class="tp-caption slide-subtitle3 tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['0','0','0','0']"
                data-y="['20','20','20','20']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['26','26','20','20']"
                data-lineheight="['26','26','20','20']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:right(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="1900"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space: nowrap;"
              >
                The amazing love of God
              </div>
              <div
                class="tp-caption slide-subtitle3 tp-resizeme rs-parallaxlevel-2"
                data-x="['left','left','left','left']"
                data-hoffset="['0','0','0','0']"
                data-y="['60','60','60','60']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['26','26','20','20']"
                data-lineheight="['26','26','20','20']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:right(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="2100"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space:"
              >
                ... a priceless gift to mankind
              </div> -->
              <!-- <router-link
                to="/donate"
                class="tp-caption colored-box slide-button cmi-donate tp-resizeme rs-parallaxlevel-2"
                data-x="['300','300','300','300']"
                data-hoffset="['0','0','0','0']"
                data-y="['200','200','200','200']"
                data-voffset="['0','0','0','0']"
                data-fontsize="['14','14','13','13']"
                data-lineheight="['15','15','13','13']"
                data-width="['none','none','none','400']"
                data-height="none"
                data-whitespace="['nowrap','nowrap','nowrap','normal']"
                data-transform_idle="o:1;"
                data-transform_in="z:0;rX:-45;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:2000;e:Back.easeInOut;"
                data-transform_out="x:right(R);s:2000;e:Back.easeIn;s:1000;e:Back.easeIn;"
                data-start="2300"
                data-splitin="none"
                data-splitout="none"
                data-responsive_offset="on"
                style="white-space: nowrap;"
                ><i class="fa tp-shape fa-shopping-cart"></i>Donate
                Now</router-link
              > -->
            </li>
          </ul>
        </div>
      </div>
      <!-- REVOLUTION SLIDER -->
    </div>
    <section>
      <div class="cmi-event-local">
        <alert-view :baseUrl="''"></alert-view>
        <event-view :baseUrl="''"></event-view>
      </div>
    </section>
    <section>
      <div class="block">
        <div class="container">
          <div class="row">
            <div class="col-md-6 column">
              <div class="service-block">
                <div class="service-image">
                  <img src="/dist/assets/images/ChurchImages/rupc_bg_0002.jpg" />
                  <i class="fa fa-bullhorn"></i>
                </div>
                <h3>SERVICES</h3>
                <p>
                  JOIN US AT LACHINE CHURCH:
                </p>
                <p>
                  Sunday Service - 2:30PM<br />
                  Wednesday Bible Study - 7:00PM<br />
                  Saturday Prayer Meeting - 7:00PM<br />
                  Lachine Rightway United Pentecostal Church<br />
                  75, 15e Avenue Lachine, QC, H8S 3L7<br />
                  (514) 701-7377
                </p>
                <router-link to="/about">READ MORE</router-link>
              </div>
            </div>
            <div class="col-md-6 column">
              <div class="service-block">
                <div class="service-image">
                  <img
                    src="/dist/assets/images/ChurchImages/rupc_bg_002.jpeg"
                  />
                  <i class="fa fa-bullhorn"></i>
                </div>
                <h3>COMMUNITY-ORIENTED</h3>
                <p>
                  Our compassion for our city includes community initiatives
                  such as education assistance with our Back 2 School supplies
                  Drive and food distribution. Sharing Jesus’ love is the core
                  of our ministry, through our outdoor events.
                </p>
                <router-link to="/toronto">READ MORE</router-link>
              </div>
            </div>
          </div>
          <div class="row cmi-home-separator1">
            <div class="col-md-6 column">
              <div class="service-block">
                <div class="service-image">
                  <img src="/dist/assets/images/ChurchImages/rupc_bg_003.jpg" />
                  <i class="fa fa-bullhorn"></i>
                </div>
                <h3>LIVELY WORSHIP EXPERIENCE</h3>
                <p>
                  We believe that genuine worship and joyful praise are central
                  to a fulfilling experience at church. We sing, we clap and use
                  instruments in our worship services.
                </p>
                <router-link to="/about">READ MORE</router-link>
              </div>
            </div>
            <div class="col-md-6 column">
              <div class="service-block">
                <div class="service-image">
                  <img src="/dist/assets/images/ChurchImages/rupc_bg_002.jpg" />
                  <i class="fa fa-bullhorn"></i>
                </div>
                <h3>POWER IN PRAYER</h3>
                <p>
                  Seeking God is both powerful and essential in a believer’s
                  walk of faith. It is the winning plan for victories to be won,
                  healing to occur and miracles to happen. There is strength in
                  numbers; therefore praying together is a key pillar of our
                  ministry. It gets us through the joyful times and challenges
                  times of our lives.
                </p>
                <router-link to="/about">READ MORE</router-link>
              </div>
            </div>
          </div>
          <div class="row cmi-home-separator1 rupc-home-format-01">
            <div class="col-md-6 col-md-offset-3">
              <h3>COME AND EXPERIENCE</h3>
              <p>
                The amazing love of God - a priceless gift to mankind
              </p>
              <p>
                His peace, which surpasses all understanding - the peace the
                world cannot offer
              </p>
              <p>
                The joy of his fellowship - which comes by worship
              </p>
              <p style="font-weight:bold;">
                "He guards the paths of the just and protects those who are
                faithful to him. Then you will understand what is right, just,
                and fair, and you will find the right way to go." - Proverbs
                2:8-9 (NLT)
              </p>
            </div>
            
          </div>
          <!-- <div class="row cmi-home-separator1">
            <div class="col-md-6 col-md-offset-3">
              <p>
                "He guards the paths of the just and protects those who are
                faithful to him. Then you will understand what is right, just,
                and fair, and you will find the right way to go." - Proverbs
                2:8-9 (NLT)
              </p>
            </div>
          </div> -->
        </div>
      </div>
    </section>
    <section>
      <div class="block">
        <div class="container">
          <div class="row">
            <div class="col-md-6 column">
              <div class="service-block">
                <div class="service-image">
                  <img
                    src="/dist/assets/images/ResourceImages/cmi_audio_cover_101_small.png"
                  />
                  <i class="fa fa-volume-up"></i>
                </div>
                <h3>AUDIO ONLINE</h3>
                <p>
                  Visit our online audio portal where we have a great stock of
                  recorded teachings for free download.
                </p>
                <router-link to="/shop-products">Audio Portal</router-link>
              </div>
            </div>
            <div class="col-md-6 column">
              <div class="service-block">
                <div class="service-image">
                  <img src="/dist/assets/images/cmi_donate_01.jpg" />
                  <i class="fa fa-heart-o"></i>
                </div>
                <h3>Help spread the word by Giving</h3>
                <p>
                  "Therefore go and make disciples of all nations, baptizing
                  them in the name of the Father and of the Son and of the Holy
                  Spirit, and teaching them to obey everything I have commanded
                  you. And surely I am with you always, to the very end of the
                  age." - Matthew 28:19-20
                </p>
                <router-link to="/donate">Donate</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="block">
        <div class="container">
          <div class="row">
            <div class="title2">
              <h2>OUR <span>MINISTRIES</span></h2>
            </div>
            <div class="col-md-12 column">
              <div class="tab-style">
                <ul class="nav nav-tabs" id="myTab2">
                  <li class="col-md-2">
                    <a data-toggle="tab" href="#tab3">Music Ministry</a>
                  </li>
                  <li class="col-md-2">
                    <a data-toggle="tab" href="#tab4">Youth Ministry</a>
                  </li>
                  <li class="col-md-2">
                    <a data-toggle="tab" href="#tab5">Kids Ministry</a>
                  </li>
                </ul>
                <div class="tab-content" id="myTabContent2">
                  <div id="tab3" class="tab-pane fade active in">
                    <div class="row">
                      <div class="col-md-8">
                        <h4>RPC WORSHIP TEAM</h4>
                        <p class="cmi-home-separator2">
                          When you become RPC member and you have the passion
                          to lead people of God in worship you can become part
                          of this worship team.
                        </p>
                      </div>
                      <div class="col-md-4">
                        <img
                          src="/dist/assets/images/ChurchImages/cmi_music_bars_01.jpg"
                        />
                      </div>
                    </div>
                  </div>
                  <div id="tab4" class="tab-pane fade">
                    <div class="row">
                      <div class="col-md-8">
                        <h4>The YOUTH</h4>
                        <p class="cmi-home-separator2">
                          The Youth Ministry hosts regular meetings focusing on
                          the different issues and challenges facing
                          today&apos;s Christian youths.
                        </p>
                        <p class="cmi-home-separator2">
                          With variety of events including outdoor and indoor activities, 
                          youth seminars and forums on relationships.
                          The Ministry aims to provide biblical and practical
                          counselling to all participants. Youths are welcomed
                          from all ages and cultures to join this open and
                          friendly Ministry group.
                        </p>
                      </div>
                      <div class="col-md-4">
                        <img
                          src="/dist/assets/images/ChurchImages/cmi_youth_01.jpg"
                        />
                      </div>
                    </div>
                  </div>
                  <div id="tab5" class="tab-pane fade">
                    <div class="row">
                      <div class="col-md-8">
                        <h4>KIDS / YOUNG ONES</h4>
                        <p class="cmi-home-separator2">
                          We have a colourful, energetic, entertaining and
                          dynamic children ministry focused on teaching
                          undiluted Word of God to our children. The primary aim
                          and objectives are to:
                        </p>
                        <ul>
                          <li>
                            <i class="fa fa-check"></i> Help the children to
                            understand the word of faith
                          </li>
                          <li>
                            <i class="fa fa-check"></i> Help the children to
                            develop their identity in Christ
                          </li>
                          <li>
                            <i class="fa fa-check"></i> Encourage the children
                            develop an understanding of God's Purpose and plan
                            for their lives
                          </li>
                          <li>
                            <i class="fa fa-check"></i> Help the children to
                            discover and use the gifts (spiritual, physical and
                            mental) that God has deposited in them
                          </li>
                          <li>
                            <i class="fa fa-check"></i> Providing learning in a
                            fun-filled, child-centred, Christ dominated
                            environment
                          </li>
                        </ul>
                        <p class="cmi-home-separator2">
                          If you have a passion to work with children please
                          make you intentions known and you will be supported.
                        </p>
                      </div>
                      <div class="col-md-4">
                        <img
                          src="/dist/assets/images/ChurchImages/cmi_kids_01.jpg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- TABS STYLE -->
            </div>
          </div>
        </div>
      </div>
    </section>
    <section>
      <div class="cmi-leaders">
        <person-view :baseUrl="''"></person-view>
      </div>
    </section>
    <section>
      <div class="block">
        <div class="container">
          <div class="row">
            <div class="col-md-8 col-md-offset-2">
              <contact></contact>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section>
      <div class="cmi-section-sp"></div>
      <div class="feedgrabbr_widget" id="fgid_197a5f8538b85dcdb88b048ac"></div>
      <script2
        >if (typeof (fg_widgets) === "undefined") fg_widgets = new Array();
        fg_widgets.push("fgid_197a5f8538b85dcdb88b048ac");</script2
      >
      <script2
        async
        src="https://www.feedgrabbr.com/widget/fgwidget.js"
      ></script2>
    </section> -->
    <section>
      <div
        class="googlemap"
        data-latlng="45.446880, -73.676960"
        data-scrollwheel="false"
        data-icon="/dist/assets/images/map_marker.png"
        data-zoom="17"
        data-theme="Default"
      >
        <div class="marker-content">
          <h4>
            Lachine Rightway <br />
            United Pentecostal Church<br />
            Église Pentecôtiste Du Vrai Chemin
          </h4>
          <p>
            929 14e Avenue<br />
            Lachine<br />
            QC H8S 4E5<br />
            Canada<br />
            (514) 701-7377
          </p>
        </div>
      </div>
    </section>
    <footer-cov></footer-cov>
  </div>
</template>
<script>
export default {
  components: {
    PersonView: () => import("../components/PersonView"),
    AlertView: () => import("../components/AlertView"),
    EventView: () => import("../components/EventView"),
    Contact: () => import("../components/Contact"),
    FooterCov: () => import("../components/FooterCoventry")
  },
  data() {
    return {};
  },
  methods: {
    callNoneVueMethods: function() {
      window.initMap();
      window.$("#slider1").revolution({
        sliderType: "standard",
        sliderLayout: "fullwidth",
        delay: 9000,
        navigation: {
          arrows: { enable: true }
        },
        gridwidth: 1100,
        gridheight: 500
      });
    }
  },
  computed: {},
  mounted() {
    this.callNoneVueMethods();
  }
};
</script>
